









































import { RuleDto } from '@/services/rule';
import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';

@Component
export default class RuleFormTab1 extends Vue {
  @PropSync('formData') syncFormData!: RuleDto;
  @Prop() id!: any;

  ruleType = ['不创建分区', '按日创建分区', '按月创建分区', '按年创建分区'];
}
